import { render, staticRenderFns } from "./FixedHero.vue?vue&type=template&id=21600e71"
import script from "./FixedHero.vue?vue&type=script&lang=js"
export * from "./FixedHero.vue?vue&type=script&lang=js"
import style0 from "./FixedHero.vue?vue&type=style&index=0&id=21600e71&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports